<template>
  <div class="login-wrapper">
    <div class="login-card">
      <h1>🏓 Ultimate Ping</h1>
      <p class="subtitle">Tournoi – Accès réservé</p>

      <form @submit.prevent="login">
        <div class="field">
          <label>Identifiant</label>
          <input
            v-model="username"
            type="text"
            placeholder="Identifiant"
            autocomplete="username"
            required
          />
        </div>
        <div class="field">
          <label>Mot de passe</label>
          <input
            v-model="password"
            type="password"
            placeholder="Mot de passe"
            autocomplete="current-password"
            required
          />
        </div>

        <p v-if="error" class="error">{{ error }}</p>

        <button type="submit" :disabled="loading">
          {{ loading ? 'Connexion...' : 'Se connecter' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import dataHandler from '@/DataHandler';
import store from '@/store';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      error: '',
      loading: false
    };
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = '';
      const credentials = btoa(this.username + ':' + this.password);
      try {
        // Tester les credentials sur un endpoint protégé
        await axios.get('/dataRequest', {
          headers: { Authorization: 'Basic ' + credentials }
        });
        // Succès : stocker les credentials et configurer axios
        sessionStorage.setItem('up_credentials', credentials);
        axios.defaults.headers.common['Authorization'] = 'Basic ' + credentials;
        // Démarrer le WebSocket maintenant que l'on est authentifié
        dataHandler.initSocketHandler(store);
        // Rediriger vers la page demandée ou la home
        const redirect = this.$route.query.redirect || '/';
        this.$router.push(redirect);
      } catch (err) {
        if (err.response && err.response.status === 401) {
          this.error = 'Identifiant ou mot de passe incorrect.';
        } else {
          this.error = 'Impossible de joindre le serveur. Réessayez.';
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
}

.login-card {
  background: white;
  border-radius: 8px;
  padding: 2.5em 3em;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  width: 100%;
  max-width: 380px;
  text-align: center;
}

h1 {
  font-size: 2em;
  margin-bottom: 0.2em;
  color: #333;
}

.subtitle {
  color: #888;
  margin-bottom: 2em;
  font-size: 0.95em;
}

.field {
  text-align: left;
  margin-bottom: 1.2em;
}

.field label {
  display: block;
  font-size: 0.85em;
  font-weight: 600;
  color: #555;
  margin-bottom: 0.4em;
}

.field input {
  width: 100%;
  padding: 0.7em 0.9em;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1em;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.field input:focus {
  outline: none;
  border-color: #404040;
}

button {
  width: 100%;
  padding: 0.8em;
  background: #404040;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1em;
  cursor: pointer;
  margin-top: 0.5em;
  transition: background 0.2s;
}

button:hover:not(:disabled) {
  background: #222;
}

button:disabled {
  background: #aaa;
  cursor: not-allowed;
}

.error {
  color: #e53e3e;
  font-size: 0.9em;
  margin-bottom: 0.5em;
}
</style>



